<template>
  <div class="subsector HCFC22">
    <div class="parent-sector">
      <p>Industrial Processes</p>
    </div>
    <div class="content">
      <div class="row">
        <div class="col-md-6">
          <h1>HCFC-22 Production</h1>
          <div class="row">
            <div class="col-sm">
              <p>
                Trifluoromethane (HFC-23) is generated and emitted as a
                byproduct during the production of chlorodifluoromethane
                (HCFC-22). HCFC-22 is used primarily as a feedstock for
                production of synthetic polymers and in emissive applications,
                primarily ref/AC.
              </p>
              <p>
                Global HFC-23 emissions from HCFC-22 production are expected to
                decrease between 2015 and 2020 but then increase through 2030
                because of the continued demand for HCFC-22 for feedstock uses,
                and then increase significantly through 2050. HCFC-22 production
                for feedstock use is expected to grow at approximately 5% per
                year.
              </p>
              <p>
                The global abatement potential for the HCFC-22 production source
                category is estimated to rise over time. In 2020, the maximum
                abatement potential is 93 MtCO₂e, or 82% of baseline emissions.
                However, abatement potential is expected to increase to 147
                MtCO₂e and 420 MtCO₂e in 2030 and 2050, respectively, or
                approximately 88% and 95% of baseline emissions. Maximum
                abatement potential can be achieved at little or no cost; all
                the potential can be reached with break-even prices between
                $0/tCO₂e and $1/tCO₂e.
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <p class="center">
            <button
              @click="
                switchComponent('ChartHCFC221');
                activate(1);
              "
              :class="{ active: active_el == 1 }"
            >Projected Emissions</button>
            <button
              @click="
                switchComponent('ChartHCFC222');
                activate(2);
              "
              :class="{ active: active_el == 2 }"
            >Reduction Potential</button>
          </p>

          <div class="container">
            <component v-bind:is="currentComp"></component>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChartHCFC221 from "@/components/industrialprocesses/ChartHCFC221";
import ChartHCFC222 from "@/components/industrialprocesses/ChartHCFC222";

export default {
  components: {
    ChartHCFC221,
    ChartHCFC222
  },
  data() {
    return {
      currentComp: "ChartHCFC221",
      active_el: 1
    };
  },
  methods: {
    switchComponent(comp) {
      //alert("test comp: " + comp);
      return (this.currentComp = comp);
    },
    activate: function(el) {
      this.active_el = el;
    }
  }
};
</script>

<style scoped>
h1 {
  font-weight: normal;
  font-size: 1.6rem;
  margin-bottom: 1rem;
}
.subsector {
  background: url("../../assets/bg-lightblue-bar.png") 0 0 repeat-x;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  border-radius: 5px;
}
.content {
  padding-top: 30px;
  padding-left: 50px;
  padding-right: 50px;
  position: absolute;
  top: 50px;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: scroll;
  overflow-x: hidden;
  min-height: 0;
}
.keypoints {
  border-left-style: solid;
  border-left-width: 5px;
  border-left-color: #b8da66;
  margin-left: 2rem;
}
.keypoints h3 {
  text-transform: uppercase;
  text-align: left;
  font-size: 1rem;
  font-family: Arial, Helvetica, sans-serif;
  font-weight: bold;
  color: #333;
  margin-left: 1rem;
  margin-bottom: 1rem;
}
.keypoints ul {
  margin-left: 1.5rem;
}
.keypoints li {
  display: list-item;
  list-style-type: disc;
  margin-bottom: 0.8rem;
}
img {
  float: right;
  margin-top: 50px;
}
button {
  background-color: #0071bc;
  border-radius: 3px;
  border: 0;
  color: #fff;
  font-size: 1rem;
  padding: 0.25rem 0.5rem;
  margin-top: 2rem;
  cursor: pointer;
  margin-left: 1rem;
}
.parent-sector {
  position: static;
  color: #012e51;
  z-index: 1;
  font-weight: bold;
  font-size: 1.2rem;
  padding-top: 10px;
  margin-left: 50px;
}

.center button {
  position: static !important;
}
</style>
